// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import { deleteComponent, getAllComponents, getComponent, updateComponent } from '../../helpers/backend_helper';
import { fetchComponentsFailure, fetchComponentsSuccess, updateComponentFailure, updateComponentSuccess } from './actions';
import { deleteComponentFailure, deleteComponentSuccess, fetchComponentFailure, fetchComponentSuccess } from '../actions';
import { DELETE_COMPONENTS_REQUEST, FETCH_COMPONENTS_REQUEST, FETCH_COMPONENT_REQUEST, UPDATE_COMPONENTS_REQUEST } from './actionTypes';
import { reduxSerializedError } from '../../utils/utils';

function* fetchComponentsSaga() {
  try {
    const response = yield call(getAllComponents);

    yield put(fetchComponentsSuccess(response.data));
  } catch (error) {
    yield put(fetchComponentsFailure(reduxSerializedError(error)));
  }
}

function* fetchComponentSaga({ payload }) {
  try {
    const response = yield call(getComponent, payload);
    yield put(fetchComponentSuccess(response));
  } catch (error) {
    yield put(fetchComponentFailure(reduxSerializedError(error)));
  }
}

function* deleteComponentsSaga({ payload }) {
  try {
    yield call(deleteComponent, payload);
    yield put(deleteComponentSuccess(payload));
    yield call(fetchComponentsSaga);
  } catch (error) {
    yield put(deleteComponentFailure(reduxSerializedError(error)));
  }
}

function* updateComponentSaga({ payload }) {
  const { project } = payload;
  try {
    yield call(updateComponent, project);
    yield put(updateComponentSuccess());
    yield call(fetchComponentsSaga); 
  } catch (error) {
    yield put(updateComponentFailure(reduxSerializedError(error)));
  }
}

export default function* rootSaga() {
  yield takeEvery(FETCH_COMPONENTS_REQUEST, fetchComponentsSaga);
  yield takeEvery(FETCH_COMPONENT_REQUEST, fetchComponentSaga);
  yield takeEvery(UPDATE_COMPONENTS_REQUEST, updateComponentSaga);
  yield takeEvery(DELETE_COMPONENTS_REQUEST, deleteComponentsSaga);
}
